export const settings = {
    "title": "Cimolai CV",
    "apiUrl": "https://api-candidati.cimolai.com/api",
    "ckdPath": "https://api-candidati.cimolai.com/",
    "config": {
        "limit": 100,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "mail": '',
    "googleMapKey": 'AIzaSyC3jRfkNCu06fxqbBFAQml91G-rhI_0iPc'

}